import { BaseEntity } from ".";
import { IGet_alliances_alliance_id_ok } from "../service/esiclient";
import moment from "moment";

export class AllianceEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Alliance";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_alliances_alliance_id_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      if (props.date_founded) {
        const date_founded = moment(props.date_founded);
        entity.properties["date_founded"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date_founded.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      // - Image
      entity.properties["image"] = {
        type: Excel.CellValueType.webImage,
        address: `https://images.evetech.net/alliances/${id}/logo`,
        altText: props.name,
      };
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
        mainImage: { property: "image" },
      },
    };

    return entity;
  }
}
